module.exports = __webpack_public_path__ + "img/bird-7-right.c7963c38.png";